// extracted by mini-css-extract-plugin
export default {"container":"BaseStylesEditor_container__yeBD1","description":"BaseStylesEditor_description__hWko5","header":"BaseStylesEditor_header__cfCDv","title":"BaseStylesEditor_title__slNY7"};